import type { SchemaDefinition } from 'validate';

export const baseSchema: SchemaDefinition = {
    phases: {
        type: 'array',
        required: true,
        each: {
            type: 'object',
            id: {
                type: 'string',
                required: true,
            },
            name: {
                type: 'string',
            },
            completed: {
                type: 'boolean',
            },
            current: {
                type: 'boolean',
            },
            nextPhaseId: {
                type: 'string',
            },
            rootPhaseId: {
                type: 'string',
            },
            icon: {
                type: 'string',
            },
            child: {
                type: 'array',
                each: {
                    type: 'object',
                    name: {
                        type: 'string',
                    },
                },
            },
        },
    },
};
